module.exports = __webpack_public_path__ + "img/menu-toggle.ba4bb78d.svg";